import {
  applyPermissionToUsersErrorFromImport,
  createDivisionAndApplyToUsersErrorFromImport,
} from 'actions/userPermissionsPage';
import SelectRedesign from 'components/Select/SelectRedesign';
import { selectableUserTypes } from 'constants/userRoles';
import { teamLikeFields } from 'constants/users';
import useAllTeams from 'hooks/teams/useAllTeams';
import { startCase } from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Role, Team } from 'types';

type ComponentProps = {
  field: string;
  users: string[];
  value: string;
};

const ErrorFieldCorrectionCard: React.FC<ComponentProps> = ({ field, users, value }) => {
  const dispatch = useDispatch();

  const { data } = useAllTeams({ kind: field });

  const [valueToApply, setValueToApply] = useState<Team | Role | null>(null);

  const handleApply = (): void => {
    if (valueToApply) {
      dispatch(
        applyPermissionToUsersErrorFromImport({
          users,
          field,
          originalValue: value,
          value: valueToApply,
        })
      );
    }
  };

  const handleAddNew = (): void => {
    dispatch(createDivisionAndApplyToUsersErrorFromImport({ field, users, value }));
  };

  const handleSelectValueToApply = (option: string): void => {
    const team = data?.records.find((t) => t.uuid === option);
    if (team) {
      setValueToApply(team);
    } else {
      setValueToApply(option as Role);
    }
  };

  const options: {
    label: string;
    value: string;
  }[] = [];
  if (teamLikeFields.includes(field) && data) {
    data.records.forEach((r) => {
      options.push({ label: r.name, value: r.uuid });
    });
  } else if (field === 'roles') {
    Object.values(selectableUserTypes)
      .filter((r) => r.label !== 'Litlingo Admin')
      .forEach((r) => {
        options.push({ label: r.label, value: r.label });
      });
  }

  const getValue = (): string => {
    if (!valueToApply) return '';
    return typeof valueToApply === 'string' ? valueToApply : valueToApply.uuid;
  };

  return (
    <div className="relative h-full flex flex-col gap-5 bg-white text-body">
      <span className="italic">
        The {field}, <b>{value}</b>, was not added for <b>{users.length} users</b>.
      </span>
      <div className="flex flex-col gap-1">
        <span>Select from the current {field} list</span>
        <div className="flex flex-row gap-2 items-center">
          <div className="w-40">
            <SelectRedesign
              value={getValue()}
              options={options}
              onChange={handleSelectValueToApply}
              placeholder={startCase(field)}
            />
          </div>
          <button
            type="button"
            className="button button--primary h-8 w-27.5 justify-center"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </div>
      {teamLikeFields.includes(field) && (
        <div className="flex flex-col">
          <span>OR</span>
          <div className="flex flex-row gap-2 items-center">
            <span>
              add <b>{value}</b>
            </span>
            <button
              type="button"
              className="button button--secondary h-8 w-18"
              onClick={handleAddNew}
            >
              <span className="font-bold whitespace-no-wrap">+ Add</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default ErrorFieldCorrectionCard;
